/**
 * @module webdnn
 */
/** Don't Remove This comment block */
/**
 * @protected
 */
export default class WeightDecoderRaw {
    async decode(data) {
        return new Float32Array(data.buffer, data.byteOffset, data.byteLength / 4);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/decoder/weight_decoder_raw.js
// module id = 33
// module chunks = 0